export default __webpack_public_path__ + "static/media/ooc-toy-model.bb87ec8a.webp";